import { render, staticRenderFns } from "./ArticlePay.vue?vue&type=template&id=b03f4b4a&scoped=true&"
import script from "./ArticlePay.vue?vue&type=script&lang=js&"
export * from "./ArticlePay.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePay.vue?vue&type=style&index=0&id=b03f4b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03f4b4a",
  null
  
)

export default component.exports